import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';
import { Parent } from '@/types/models';
import ParentsSection from '../sidebar/ParentsSection';

interface FamilyParentsTabProps {
  parents: Parent[];
  onAddParent: () => void;
  onSendInvite: (parentId: string) => void;
  onEditParent: (parent: Parent) => void;
  onDeleteParent?: (parent: Parent) => void;
  onToggleParentActiveStatus?: (parent: Parent, isActive: boolean) => void;
}

const FamilyParentsTab = ({
  parents,
  onAddParent,
  onSendInvite,
  onEditParent,
  onDeleteParent,
  onToggleParentActiveStatus
}: FamilyParentsTabProps) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Parents</CardTitle>
        <Button variant="outline" onClick={onAddParent} className="gap-1">
          <UserPlus className="h-4 w-4" />
          Add Parent
        </Button>
      </CardHeader>
      <CardContent>
        <ParentsSection 
          parents={parents} 
          onAddParent={onAddParent}
          onSendInvite={onSendInvite}
          onEditParent={onEditParent}
          onDeleteParent={onDeleteParent}
          onToggleActiveStatus={onToggleParentActiveStatus}
          expanded
        />
      </CardContent>
    </Card>
  );
};

export default FamilyParentsTab;
